import keycloakAxios from '@/services/axios';

export const cancelPayment = async (eventId: string) => {
  const response = await keycloakAxios.post('payments/cancel-payment', {
    eventId
  });

  if (response.status >= 300) {
    throw new Error(
      `Error cancelling payment: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
